import { axios } from '@/utils/request'

const api = {

  master: '/master/masterApplets',
}
// 列表
export function queryIdCardList (parameter) {
  return axios({
    url: api.master + '/getIdentityList',
    method: 'get',
    params: parameter
  })
}

// 审核个人信息
export function review (parameter) {
  return axios({
    url: api.master + '/review',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 新增
export function trainSave (parameter) {
  return axios({
    url: api.master + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 详情
export function getIdentityById (id) {
  return axios({
    url: api.master + '/getIdentityById',
    method: 'get',
    params: {
      id:id
    }
  })
}
